export default __webpack_public_path__ + "static/media/a13e986cb9081af1.cbe7d64f955f9d5dadc03d5ba1d3e331.svg";